module.exports = __webpack_public_path__ + "img/swingLines3.fb6fecaa.png";